import styled from "styled-components";
import { Tooltip as CustomTooltip } from "antd";

export const StyledTooltip = styled(CustomTooltip)`
  cursor: pointer;

  .ant-tooltip-inner {
    max-width: 522px;
  }
`;
